import React, { useState, useEffect } from "react";
import "./DecisionScreen.css";
import SpinnerOverlay from "../components/spinnerOverlay/SpinnerOverlay";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const DecisionScreen = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [selectedRole, setSelectedRole] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // console.log("user in decision screen", user);

  const handleRoleChange = (role) => {
    setSelectedRole(role === selectedRole ? "" : role);
    setError("");
  };

  useEffect(() => {
    // Only redirect if user is fully registered (has role AND profile completed or not pending)
    if (user && user.role && user.role !== "pending") {
      const homeRoute =
        user.role === "student"
          ? "/student-home"
          : user.role === "tutor"
          ? "/tutor-home"
          : user.role === "institution"
          ? "/academy-home"
          : "/";

      navigate(homeRoute, { replace: true });
    }
  }, [user, navigate]);


  const handleContinue = async () => {
    if (!selectedRole) return;

    setIsLoading(true);
    setError("");

    try {

      // Always go to Create Account form next
      navigate("/create-account", {
        state: { selectedRole },
      });
    } catch (err) {
      setError("Failed to save role. Please try again.");
      setIsLoading(false);
    }
  };
  return (
    <div className="decision-container">
      {isLoading && <SpinnerOverlay />}
      <div className="logo-container">
        <img
          src="/images/tutors-logo.png"
            // src={`${process.env.PUBLIC_URL}/tutors-logo.png`}
          alt="Website Logo"
          className="decision-logo"
        />
      </div>
      <main className="main-content">
        <div className="welcome-text">
          <h2>
            Welcome to <span>TutorsLinks!</span>
          </h2>
          <p className="welcome-subtitle">
            Hi {user?.firstName || "there"}! Please choose how you'd like to
            continue:
          </p>{" "}
        </div>

        {error && (
          <p className="error" style={{ color: "red", textAlign: "center" }}>
            {error}
          </p>
        )}
        <div className="role-selection">


          <div
            className={`role-option ${
              selectedRole === "tutor" ? "selected" : ""
            }`}
            onClick={() => handleRoleChange("tutor")}
          >
            <div className="radio-container">
              {selectedRole === "tutor" && <div className="check-icon"></div>}
              <div className="radio-button"></div>
            </div>
            <div className="profile-icon">
              <img 
              src="/images/scroll-pic2.jpg"
              // src={`${process.env.PUBLIC_URL}/images/picture3.png`}
              alt="tutor" className="" 
              />
            </div>
            <div className="role-info">
              <h3>Join as Tutor(Individual)</h3>
              <p className="role-description">
                Share your knowledge and earn by teaching students
              </p>
            </div>
          </div>

          <div
            className={`role-option ${
              selectedRole === "institution" ? "selected" : ""
            }`}
            onClick={() => handleRoleChange("institution")}
          >
            <div className="radio-container">
              {selectedRole === "institution" && (
                <div className="check-icon"></div>
              )}
              <div className="radio-button"></div>
            </div>
            <div className="profile-icon">
              <img
                src="/images/scroll-pic3.jpg"
                // src={`${process.env.PUBLIC_URL}/images/picture4.png`}
                alt="institution"
                className=""
              />
            </div>
            <div className="role-info">
              <h3>Join as Training Center</h3>
              <p className="role-description">
                Offer professional training to students and tutors
              </p>
            </div>
          </div>

                    <div
            className={`role-option ${
              selectedRole === "student" ? "selected" : ""
            }`}
            onClick={() => handleRoleChange("student")}
          >
            <div className="radio-container">
              {selectedRole === "student" && <div className="check-icon"></div>}
              <div className="radio-button"></div>
            </div>
            <div className="profile-icon">
              <img 
              src="/images/scroll-pic1.png" 
              alt="student" className="" />
            </div>
            <div className="role-info">
              <h3>Join as Learner/Student</h3>
              <p className="role-description">
                Find and book the best tutors for your learning needs
              </p>
            </div>
          </div>
        </div>

        <div className="button-section">
          <button
            className="continue-button"
            onClick={handleContinue}
            disabled={!selectedRole || isLoading}
          >
            {isLoading ? "Saving..." : "Continue"}{" "}
            <span className="arrow">→</span>
          </button>
          <p>
            Pressing continue means you agree to our{" "}
            <a href="/terms-and-conditions" className="terms-link">
              Terms and Conditions
            </a>
          </p>
        </div>
      </main>
    </div>
  );
};

export default DecisionScreen;
